import { buildCategoryEventName } from './buildCategoryEventName';

export function generateAnalyticsInteractionEvent(section, target, component = 'overlay') {
  const { category, eventInfo } = buildCategoryEventName('interaction', 'pip sub-content');
  return {
    category,
    eventInfo,
    subContent: {
      component,
      section,
      target,
    },
  };
}